import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserFacade } from 'src/app/store/user/facade';
import { UserModel } from 'src/app/store/user/model';
import { AppConstants } from '../../../core/constants/app-constants';
import { PermissionConstants } from '../../../core/constants/permission-constants';
import { List } from '../../../core/infrastructure/linq';
import { AuthService } from '../../../core/services/auth-service';
import { OrderFacade } from '../../../store/order/facade';
import { OrderModel } from '../../../store/order/model';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { ProblemForUserFacade } from '../../../store/problem-user/facade';
import { ProblemModel } from '../../../store/problem/model';
import serviceCatalogRu from '../../../../assets/i18n/introRu.json';
import serviceCatalogUk from '../../../../assets/i18n/introUk.json';
import { BellOrders, NotificationForOrdersType } from '../../../store/order/model';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  host: {
    class: 'd-block',
    id: 'appToolbar',
  },
  standalone: false,
})
export class ToolbarComponent implements OnInit {
  translate = inject(TranslateService);
  private userFacade = inject(UserFacade);
  authService = inject(AuthService);
  private router = inject(Router);
  sanitizer = inject(DomSanitizer);
  private problemForUserFacade = inject(ProblemForUserFacade);
  private orderFacade = inject(OrderFacade);

  public user: UserModel;
  public permissions = PermissionConstants;
  public fullName: string;
  public problems$: Observable<ProblemModel[]>;
  public orders$: Observable<OrderModel[]>;
  public ordersIsLoading: boolean = false;

  public bellOrders$: Observable<BellOrders>;
  public bellOrdersIsLoading: boolean = false;

  private selfDiagnosticServiceCatalogUrl: string = '/self-diagnostic/service-catalog';
  private nextTextButton: string;
  private prevTextButton: string;
  private doneTextButton: string;
  //private introJS = introJs();
  public isDisabledInfo: boolean = true;

  public isShowNotificationMenu: boolean = false;

  public ngOnInit(): void {
    this.userFacade.selected().subscribe(user => {
      this.user = user;

      if (user) {
        this.fullName = this.user.userName;
      }
    });

    this.problems$ = this.problemForUserFacade.allProblems$;
    this.orders$ = this.orderFacade.allOrders$;

    this.bellOrders$ = this.orderFacade.ordersForNotification$.pipe(
      map(item => {
        const bellOrders = new BellOrders();
        if (item && item.length > 0) {
          let findedItems: OrderModel[];

          findedItems = item.find(x => x.typeId === NotificationForOrdersType.estimate)?.orders;
          bellOrders.estimate = findedItems && findedItems.length > 0 ? findedItems : [];

          findedItems = item.find(x => x.typeId === NotificationForOrdersType.agreement)?.orders;
          bellOrders.agreement = findedItems && findedItems.length > 0 ? findedItems : [];
        }
        return bellOrders;
      })
    );

    // Удалить это обязательно!!!!!!! Только для теста
    /*
    this.bellOrders$ = this.orderFacade.allOrders$.pipe(map( item => {
      const bellOrders = new BellOrders();
      if (item && item.length > 0) {
        let findedItems: OrderModel[];

        bellOrders.estimate = item.concat(item);

      };
      return bellOrders;
    }));
    */
    //---

    this.orderFacade.loadForNotification();
    this.orderFacade.isLoadingForNotification().subscribe(x => (this.bellOrdersIsLoading = x));
    this.orderFacade.isLoading().subscribe(x => (this.ordersIsLoading = x));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isDisabledInfo = true;
        if (event.url === this.selfDiagnosticServiceCatalogUrl) {
          this.isDisabledInfo = false;
          const stor = JSON.parse(localStorage.getItem(event.url));

          if (!stor) {
            localStorage.setItem(event.url, JSON.stringify(true));
            this.showMasterHelpByUrl(event.url);
          }
        }
      }
    });
  }

  public goHome() {
    this.router.navigate(['/']);
  }

  public goToProfilePage() {
    this.router.navigate(['/profile']);
  }

  public goToAdminPanel() {
    this.router.navigate(['/admin/dashboard']);
  }

  public goToStepsDiagnostic() {
    this.router.navigate(['/self-diagnostic/service-catalog']);
  }

  // public goToOrdersPage() {
  //   this.router.navigate(['/orders']);
  // }

  public goToIssuesPage() {
    this.router.navigate(['/orders']);
  }

  public goToProblemPreviewPage(problem) {
    this.router.navigate(['/problem/preview', problem.id]);
  }

  public logout() {
    this.authService.logOut();
  }

  // public showMasterHelp() {
  //   this.showMasterHelpByUrl(this.router.url);
  // }

  public createIssue() {
    this.router.navigate(['/self-diagnostic/service-catalog']);
  }

  private showMasterHelpByUrl(url: string) {
    let introData = null;
    if (url === this.selfDiagnosticServiceCatalogUrl) {
      introData = this.translate.currentLang == AppConstants.LANGUAGE_UK ? serviceCatalogUk : serviceCatalogRu;
    }

    if (introData) {
      this.translate.get('READ_MORE').subscribe(value => {
        this.nextTextButton = value;
      });
      this.translate.get('PREV').subscribe(value => {
        this.prevTextButton = value;
      });
      this.translate.get('DONE').subscribe(value => {
        this.doneTextButton = value;
      });
      /*
      Треба розібратись на що його замінити і чи потрібно воно взагалі
      this.introJS
        .setOptions({
          steps: introData,
          nextLabel: this.nextTextButton,
          prevLabel: this.prevTextButton,
          doneLabel: this.doneTextButton,
        })
        .start();
      */
    }
  }

  public showNotificationMenu() {
    this.isShowNotificationMenu = !this.isShowNotificationMenu;
  }
}
